<script setup lang="ts">
import {PropType, toRef, ToRef} from "vue";
// @ts-ignore
import AppController from "@target/components/App/ts/AppController";
import {PageOpenIn} from "@enums/PageOpenIn";

interface IProps {
	actionText: string;
}

defineProps<IProps>();

function toRules() {
    AppController.getInstance().routerService.toRules(PageOpenIn.POPUP, true);
}
</script>

<template>
    <div class="view-payment-create-config-rules">
        <p>{{ $t('newPayment.rules.text', {text: actionText}) }}<span @click="toRules" class="link">{{$t('newPayment.rules.link') }}</span></p>
    </div>
</template>

<style lang="scss">
.view-payment-create-config-rules {
    margin: 12px 0 0 0;
    text-align: center;

    p {
        @include text(12px, 400, var(--grey2), 120%);
    }

    .link {
        color: var(--blue1);
		display: inline;
    }
}
</style>
